import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useDeleteDraft } from './useDeleteDraft';
import { useMessageDialogStore } from '../../../store';
import { useCustomToast } from '../../useCustomToast';

const DELETE_DRAFT_FAILED_MESSAGE = 'Failed to delete draft';

export function useDeleteDraftWithToast({
  subscribe = true,
}: {
  subscribe?: boolean;
} = {}) {
  const { t } = useTranslation();
  const { promiseToast } = useCustomToast();
  const { deleteDraft, captureDraftSnapshot } = useDeleteDraft({ subscribe });

  return useCallback(
    (draftId: string) => {
      const promise = (async () => {
        const snapshot = subscribe ? undefined : captureDraftSnapshot(draftId);
        await useMessageDialogStore.getState().closeIfShowingDraft(draftId);
        const success = await deleteDraft(
          draftId,
          subscribe
            ? { removeFromStore: true }
            : { removeFromStore: true, snapshot },
        );

        if (!success) {
          throw new Error(DELETE_DRAFT_FAILED_MESSAGE);
        }
      })();

      return promiseToast(
        promise,
        t('inbox.userCommunication.actions.deletingDraft'),
        t('inbox.userCommunication.actions.deleteDraftSuccess'),
        t('inbox.userCommunication.actions.deleteDraftError'),
      );
    },
    [deleteDraft, captureDraftSnapshot, subscribe, promiseToast, t],
  );
}
